import { ApiGet, ApiPost } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '@/stores/SettingsStore.ts'
import type { ITermsVersionViewModel } from '../types/ContractAgreementTypes'

/**
 * Retrieves the terms and conditions for a consultant contract agreement
 * @param beeNumber The BEE number of the consultant
 * @returns Promise with the terms version view model
 */
export async function TermsNUWGet(beeNumber: number | null, countryCode?: string, codeIdTermsType?: string) {
  const url = await GetOrderEntryConnectorUrl('TermsNUWGet')
  
  return ApiGet(url, {
    BeeNumber: beeNumber ?? 0,
    CountryCode: countryCode,
    CodeIdTermsType: codeIdTermsType
  })
}

/**
 * Creates a record of the consultant's agreement to the terms
 * @param termsAgreement The terms agreement data
 * @returns Promise with the create response
 */
export async function TermsNUWCreate(termsAgreement: {
  termsId: number;
  beeNumber: number;
  codeIdTermsType: string;
}) {
  const url = await GetOrderEntryConnectorUrl('TermsNUWCreate')
  
  return ApiPost(url, termsAgreement)
}
